"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_CHECKOUT_OFFER_HINTS_CONTEXT = void 0;
const noop = () => {
  // empty implementation intended
};
const DEFAULT_CHECKOUT_OFFER_HINTS_CONTEXT = exports.DEFAULT_CHECKOUT_OFFER_HINTS_CONTEXT = {
  isDoubleCurrency: false,
  offersCount: 0,
  setIsOfferHintsModalOpen: noop,
  setNotAvailableOfferIds: noop,
  toggleConfirmationModal: noop
};